import { render, staticRenderFns } from "./branchCardComponent.vue?vue&type=template&id=8b34f3ca"
import script from "./branchCardComponent.vue?vue&type=script&lang=js"
export * from "./branchCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports